<script>
import VueDataLoading from "vue-data-loading";
import Multiselect from 'vue-multiselect'

import mergeByKey from "array-merge-by-key"
import Loading from 'vue-loading-overlay'
import locationIcon from "../../images/location-pin-secondary.svg"
import proMemberIcon from '../../images/pro-member-tag.svg'
import Rating from "./Rating.vue"
import 'vue-loading-overlay/dist/vue-loading.css'

import axiosApi from '../shared/api.js'
import Filters from './Filters.vue'

import closeImage from '../../images/close-orange.svg'
import shieldImage from '../../images/shield.svg'
import Breadcrumbs from "./Breadcrumbs.vue";
import caitriona from '../../images/caitriona.png'
import yazan from '../../images/yazan.png'
import fadi from '../../images/fadi.png'
import raya from '../../images/raya.png'
import blueTick from '../../images/blue-tick.png'
import ratingStarActive from "../../images/rating-star-active.svg"

export default {
  data() {
    return {
      countries: [],
      closeImage: closeImage,
      shieldImage: shieldImage,
      caitriona: caitriona,
      yazan: yazan,
      fadi: fadi,
      raya: raya,
      blueTick: blueTick,
      ratingStarActive: ratingStarActive,
      sidebarShow: false,
      locationChanged: false,
      locationIcon: locationIcon,
      proMemberIcon: proMemberIcon,
      artists: [],
      page: 1,
      loading: false,
      completed: false,
      current_city: '',
      artfin: [],
      query: {
        by_city: this.loadParams('city').split(','),
        by_art_type: this.loadParams('art_type').split(','),
        by_event_type: this.loadParams('event_type').split(','),
        by_genre: this.loadParams('genre').split(','),
        by_max_budget: this.loadParams('max_budget'),
        by_performance_type: this.loadParams('performance_type').split(','),
        by_speciality: this.loadParams('speciality').split(','),
        by_language: this.loadParams('language').split(',')
      },
      location: localStorage.getItem('location_country'),
      current_location: localStorage.getItem('short_form', ''),
      artType: "DJ",
      activeCountry: this.selectedCountry,
      currency: localStorage.getItem('location_currency'),
      country_id:  localStorage.getItem('country_id'),
      newFiltersData: {}
    };
  },
  components: {
    Breadcrumbs,
    VueDataLoading,
    Filters,
    Loading,
    Rating,
    Multiselect
  },
  props: {
    discoverFilters: Array,
    discoverFilterIcons: Array,
    artTypeFilter: Array,
    specialityFilter: Array,
    genreFilter: Array,
    countryFilter: String,
    eventTypeFilter: Array,
    cityNameFilter: Array,
    cityFilter: Array, 
    convertedPrice: String,
    searchLocation: String,
    currencyCode: String,
    showBookingButton: Boolean,
    logged: Boolean,
    onlyHeader: Boolean,
    selectedCountry: Object
  },
  mounted() {
    this.page = 1;
    localStorage.setItem('show_city', true)
    if (localStorage.getItem('token') === '') {
      axiosApi.post('/users/tokens/guest')
        .then(response => {
          localStorage.setItem('token', response.data.jwt)
          axiosApi.defaults.headers.common['Authorization'] = response.data.jwt
          this.loadData()
        })
    } else {
      this.loadData()
    }
  },
  watch: {
    artists(ss, oldSs) {
      this.artfin = ss;
    },
    sidebarShow(ss) {
      if (ss) {
        document.querySelector("body").style = "overflow: hidden;";
      } else {
        document.querySelector("body").style = null;
      }
    },
  },
  methods: {
    loadParams(param_type) {
      if (param_type== "city" && this.countryFilter && this.countryFilter != localStorage.getItem('location_country').toLowerCase()) {
        let country
        this.$axios.get('/locations')
        .then(response => {
          country = response.data.filter((country)=> country.slug && country.slug.toLowerCase() == this.countryFilter)
          this.onCountrySelect(country[0])
        })
      }
      if (param_type== "art_type" && this.artTypeFilter.length > 0) {
        return this.artTypeFilter.join(',')
      }
      else if (param_type== "speciality" && this.specialityFilter.length > 0){ 
        return this.specialityFilter.join(',')
      }
      else if (param_type== "genre" && this.genreFilter.length > 0){ 
        return this.genreFilter.join(',')
      } 
      else if (param_type== "city" && this.cityFilter.length > 0) { 
        return this.cityFilter.join(',')
      }
      else if (param_type== "event_type" && this.eventTypeFilter.length > 0) { 
        return this.eventTypeFilter.join(',')
      }
      return ''
    },
    loadData() {
      this.loadArtists(this.query);
      this.$refs.filtersComponent.initData(this.query);
      window.addEventListener("storage", this.changeStorage)
    },
    formattedAmount(amount) {
      if (amount != '') {
        return Math.round(amount).toLocaleString()
      } else {
        return 0
      }
    },
    formattedTax(amount, percentage ){
      if (amount != '') {
        let inputPrice = (amount * percentage) / 100;
        return Math.round(inputPrice);
      } else {
        return 0
      }
    },
    breadcrumbsData() {
      return {
        selectedCountry: this.selectedCountry,
        cityNameFilter: this.cityNameFilter,
        artTypeFilter:  this.artTypeFilter,
        specialityFilter: this.specialityFilter,
        genreFilter: this.genreFilter,
      }
    },
    openCountrySelect () {
      this.$refs.multiselect.activate();
    },
    openInternationalOptionsModal () {
      if (this.countries.length > 0) {
        this.$modal.show('country-selection-modal')
      } else {
        this.$axios({url: '/global_settings/countries', baseURL: '', method: 'get'})
        .then(response => {
          this.countries = response.data
          this.$modal.show('country-selection-modal')
        })
      }
    },
    onCountrySelect(option) {
      this.activeCountry = option
      this.$axios({url: `/global_settings/select_country?id=${option.id}`, baseURL: '', method: 'post'})
        .then(response => {
          this.$modal.hide('country-selection-modal')
          localStorage.setItem('location_currency', response.data.currency.code)
          localStorage.setItem('location_country', option.slug)
          localStorage.setItem('country_name', option.name)
          localStorage.setItem('short_form', option.short_form)
          localStorage.setItem('country_id', option.id)
          window.history.replaceState(null, null, option.short_form);
          window.dispatchEvent(new CustomEvent('currency-changed', { detail: { country: option } }))
          window.dispatchEvent( new Event('storage') )
          window.scrollTo({ top: 0, behavior: 'smooth' })
        })
    },
    changeStorage(event) {
      if (localStorage.getItem('location_country') !== this.location) {
        if (localStorage.getItem('location_currency') !== this.currency) {
          this.currency = localStorage.getItem('location_currency')
        }
        this.locationChanged = true
        this.query.by_city = ['']
        this.location = localStorage.getItem('location_country')
        this.$refs.filtersComponent.initData(this.query);
        this.$refs.filtersComponent.updateQuery();
        this.loadArtists(this.query);
      } 
      if(localStorage.getItem('language_slug')) {
        this.$refs.filtersComponent.initData(this.query);
        this.$refs.filtersComponent.updateQuery();
        this.loadArtists(this.query);
      }
      if (localStorage.getItem('location_currency') !== this.currency) {
        this.currency = localStorage.getItem('location_currency')
        this.loadArtists(this.query);
      }
    },
    loadArtists(query) {
      let location = this.location
      this.loading = true
      axiosApi.get('/artists', {
        params: {
          ...query,
          location: location,
          currency: this.currency,
          country_id: this.country_id,
          page: this.page,
          per_page: 30
        }
      })
        .then(response => {
          if (this.page == 1) {
            this.artists = response.data
          } else {
            this.artists = mergeByKey("slug", this.artists, response.data);
          }
          if (response.data.length < 30) this.completed = true;
          this.loading = false
          this.updateArtistsListSchema();
          this.updateLocalBusinessSchema();
        })
        this.current_location = query.by_city.length > 0 ? window.location.pathname.split('/')[2].toUpperCase() : localStorage.getItem('short_form', '')
    },
    updateQuery(query) {
      let newQuery = {}

      for(var key in query) {
        if (Array.isArray(query[key])) {
          newQuery = Object.assign(newQuery, {[key]: query[key]})
        } else {
          newQuery = Object.assign(newQuery, {[key]: [query[key]]})
        }
      }

      this.query = newQuery;
    },
    loadNextPage() {
      this.page++;
      this.loadArtists(this.query);
    },
    showSidebar() {
      if (document.querySelector(".main-container").clientWidth < 1024) {
        this.sidebarShow = !this.sidebarShow;
      }
    },
    filtersChangeHandler(value) {
      this.query = value;
      this.page = 1;
      if (localStorage.getItem('location_country') !== this.location || this.locationChanged) {
        this.query.by_city = ['']
      }
      this.locationChanged = false
      this.loadArtists(this.query);
      this.completed = false
    },
    updateBreadcrumbs(breadcrumbsData) {
      this.newFiltersData = breadcrumbsData;
      this.$refs.breadcrumbsComponent.updateData({
        ...this.breadcrumbsData(),
        ...breadcrumbsData
      });
    },
    updateArtistsListSchema() {
      const scriptId = 'artists-data-list';
      let scriptElement = document.getElementById(scriptId);
      if (!scriptElement) {
        scriptElement =  document.createElement('script');
        scriptElement.type = 'application/ld+json';
        scriptElement.id = scriptId;
        document.head.appendChild(scriptElement);
      }
      const artistListData = this.artists.map((artist, index) => {
        const { protocol, hostname, port } = window.location;
        const url = `${protocol}//${hostname}${port ? `:${port}` : ''}/artist/${artist.slug}`;
        const name = artist.stage_name ? artist.stage_name : artist.full_name;

        let item = {
          "@type": "Product",
          "name": `Performance by ${name}`,
          "brand": {
            "@type": "Brand",
            "name": name,
            "url": url
          },
        }

        if (artist.avatar) {
          item.image = [
            artist.avatar.small,
            artist.avatar.medium,
            artist.avatar.large,
          ];
          item.brand.image = artist.avatar.medium;
        }

        if (artist.reviews_count > 0){
          item.aggregateRating = {
            "@type": "AggregateRating",
            "ratingValue": artist.overall_rating,
            "reviewCount": artist.reviews_count,
            "bestRating": 5,
          }
        }

        if (artist.price_from) {
          item.offers = {
            "@type": "Offer",
            "priceCurrency": artist.price_from.currency,
            "price": artist.price_from.amount,
            "url": url,
            "availability": "https://schema.org/InStock",
            "itemCondition": "https://schema.org/NewCondition"
          }
        }


        return {
          "@type": "ListItem",
          "position": index + 1,
          "item": item
        }
      }).filter(data => data.item.aggregateRating || data.item.offers);

      scriptElement.innerHTML = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement": artistListData
      }, null, 2);
    },
    updateLocalBusinessSchema() {
      if (this.newFiltersData.artTypeFilter?.length === 0) {
        return;
      }

      const scriptId = 'local-business-schema';
      let scriptElement = document.getElementById(scriptId);
      if (!scriptElement) {
        scriptElement =  document.createElement('script');
        scriptElement.type = 'application/ld+json';
        scriptElement.id = scriptId;
        document.head.appendChild(scriptElement);
      }
      const prices = this.artists
          .filter(item => item.price_from !== null)
          .map(item => item.price_from.amount);

      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);
      const avgPrice = prices.reduce((sum, price) => sum + price, 0) / prices.length;
      scriptElement.innerHTML = JSON.stringify({
        '@context': "https://schema.org",
        '@type': "LocalBusiness",
        "name": this.newFiltersData.artTypeFilter.map(i => i.name),
        "url": window.location.href,
        "currenciesAccepted": ["USD", "EUR", "GBP", "DKK", "AED"],
        "paymentAccepted": "Credit Card, Debit Card, Cash",
        "openingHours": "Mo-Su",
        "logo": "https://soulartists.net/og-image.png",
        "priceRange": `${this.currencyCode} ${minPrice} - ${this.currencyCode} ${maxPrice} (Avg: ${this.currencyCode} ${avgPrice})`,
        "image": "https://soulartists.net/og-image.png",
        "address": {
          "addressLocality": this.selectedCountry.name,
          "addressCountry": this.selectedCountry.code
        },
      }, null, 2);
    },
  },
  beforeDestroy() {
    document.querySelector("body").style = null;
    window.removeEventListener("storage", this.changeStorage)
    localStorage.removeItem('show_city')
    localStorage.removeItem('country_name')
  },
  head: {
    meta: function() {
      return [
        {
          property: "og:image",
          content: location.origin + "/og-image.png",
          id: "og-image"
        },
        {
          property: "twitter:image",
          content: location.origin + "/og-image.png",
          id: "twitter-image"
        },
        { property: "og:url", content: location.origin, id: "og-url" }
      ];
    }
  }
};
</script>

<template>
  <div>
    <filters
      ref="filtersComponent"
      @queryChanged="filtersChangeHandler"
      @breadcrumbsUpdate="updateBreadcrumbs"
      :showBookingButton="showBookingButton"
      :discoverFilterItems="discoverFilters"
      :discoverFilterIcons="discoverFilterIcons"
      :artTypeFilter="artTypeFilter"
      :genreFilter="genreFilter"
      :specialityFilter="specialityFilter"
      :cityNameFilter="cityNameFilter"
      :eventTypeFilter="eventTypeFilter"
      :searchLocation="searchLocation"
      :selectedCountry="selectedCountry"
      :logged.sync="logged"
      :onlyHeader="false"
      :sidebarShow.sync="sidebarShow">

      <div class="vld-parent">
        <loading :active.sync="loading"
          :can-cancel="false"
          :is-full-page="true"
          color="#FF8141"
        ></loading>
      </div>

      <!-- <div class="discover-filter" v-if="!sidebarShow">
        <h1 @click="showSidebar">Filters</h1>
      </div> -->

      <div class="discover-list">
        <div id="instant-quote-modal" class="vm--container" x-data="{ 'isBookingDialogOpen': false }" x-show="isBookingDialogOpen" x-cloak>
          <div data-modal="share-modal" aria-expanded="true" class="vm--overlay">
            <div class="vm--top-right-slot"></div>
          </div>
          <div aria-expanded="true" role="dialog" aria-modal="true" class="vm--modal instant-quote-modal__content">
            <div class="instant-quote-modal__header">
              <span id="instant-quote-close-btn" class="instant-quote-modal__close">x</span>
            </div>

            <div id="instant-quote-modal-body" class="instant-quote-modal__body">
              <div id="vue-new-booking"></div>
            </div>
          </div>
        </div>
        <Breadcrumbs
            ref="breadcrumbsComponent"
            :selectedCountry="selectedCountry"
            :cityNameFilter="cityNameFilter"
            :artTypeFilter="artTypeFilter"
            :specialityFilter="specialityFilter"
            :genreFilter="genreFilter"
        />

        <vue-data-loading
          :loading="loading"
          :completed="completed"
          :location="location"
          :init-scroll="false">

          <a
            :href="`/artist/${artist.slug}`"
            v-for="artist in artfin"
            :key="artist.slug"
            class="discover-item d-flex">
            <div class="discover-item__avatar mobile-avatar col-5">
              <div :href="`/artist/${artist.slug}`" class="discover-avatar-container">
                <div class="overflow-hidden">
                  <img :src="artist.avatar ? artist.avatar.large : null" :alt="artist.stage_name" class="discover-item__avatar">
                  <img v-if="artist.featured" :src="proMemberIcon" class="pro-member-badge" alt="pro member badge">
                </div>
              </div>
            </div>
            <div class="discover-item-all-info position-relative col-6 p-0">
              <div class="discover-item__info">
                <div class="d-flex align-items-center mb-1">
                  <h3 class="discover-item__name text-capitalize mb-0">
                    {{ artist.stage_name ? artist.stage_name : artist.full_name }}
                  </h3>
                </div>

                <div class="d-flex align-items-center">
                  <img :src="locationIcon" style="width: 10px; height: 15px;" alt="location"/>
                  <p class="discover-item__desc ms-1 lh-1 text-truncate">
                    {{ artist.city ? artist.city.name : '' }}, {{ artist.location ? artist.location.name : '' }}
                    {{ artist.art_type ? ' • ' + artist.art_type.name : '' }}
                  </p>
                </div>

                <rating
                  class="discover-item__rating"
                  v-if="artist.overall_rating > 0"
                  :rating="artist.overall_rating"
                  :reviews_count="artist.reviews_count"
                />

                <p class="discover-item__specialities mt-1 lh-1 text-truncate">
                  {{ artist.specialities.map(specialities => (specialities.name)).join(', ') }}
                </p>
              </div>

              <div class="discover-item__price_info_mobile position-absolute bottom-0">
                <p v-if="artist.price_from" class="mb-0 lh-1">From</p>
                <h2 v-if="artist.price_from" class="mt-0 mb-0 lh-1">
                  {{ artist.price_from.currency }} {{ formattedAmount(artist.price_from.amount) }}
                </h2>
                <p
                  v-if="artist.price_from"
                  class="small">
                + {{ artist.price_from.currency }} {{ formattedTax(artist.price_from.amount, artist.tax_percentage) }} taxes and charges
                </p>
              </div>
            </div>

            <div class="discover-item__price ms-auto">
              <div class="discover-item__price_info">
                <p v-if="artist.price_from" class="mb-0 lh-1">From</p>
                <h2 v-if="artist.price_from" class="mt-0 lh-1">
                  {{ artist.price_from.currency }} {{ formattedAmount(artist.price_from.amount) }}
                </h2>
                <p
                  v-if="artist.price_from"
                  class="small mb-1">
                  + {{ artist.price_from.currency }} {{ formattedTax(artist.price_from.amount, artist.tax_percentage) }} taxes and charges
                </p>
                <a class="discover-item__more primary" :href="`/artist/${artist.slug}`">
                  View profile
                </a>
              </div>
            </div>
          </a>

          <div slot="infinite-scroll-loading"></div>

          <div class="location-search">
            <modal
              name="country-selection-modal"
              height="auto"
              :adaptive="true"
              @opened="openCountrySelect">
              <multiselect
                ref="multiselect"
                :value="activeCountry"
                @select="onCountrySelect"
                placeholder="Search country"
                :options="countries"
                label="name"
                :internalSearch="true"
                track-by="id">
                <span slot="noResult">Nothing was found</span>
              </multiselect>
              <div></div>
            </modal>
          </div>

          <div slot="completed">
            <button
              class="btn secondary international-options-btn shadow w-100 d-flex align-items-center justify-content-center"
              @click="openInternationalOptionsModal">
              <div class="appbar-list__global-icon"></div>
              Show international options
            </button>
          </div>
        </vue-data-loading>
        <button class="btn secondary international-options-btn shadow w-100 d-flex align-items-center justify-content-center" v-if="!completed" @click="loadNextPage">Load More</button>
      </div>
    </filters>
  </div>
</template>
<style lang="scss" scoped>

</style>
